import { apiClient } from '../client'

export type DataRange = '1' | '7' | '30' | '365' | 'max'

export interface GetAssetMarketChartRequest {
  chainId: string
  denom: string
  range?: DataRange
}

export type GetAssetMarketChartRawResponse = {
  prices: [number, number][]
  fetched_at: number
}

interface AggregatedPrice {
  time: string
  price: number
  shortDate: string
  timestamp: number
}

export type GetAssetMarketChartResponse = {
  prices: AggregatedPrice[]
  fetchedAt: number
  maxValue: number
  minValue: number
  priceChange: number
}

export function getAssetMarketChart({
  chainId,
  denom,
  range = 'max',
}: GetAssetMarketChartRequest): Promise<GetAssetMarketChartRawResponse> {
  const searchParams = new URLSearchParams()
  searchParams.append('chain-id', chainId)
  searchParams.append('denom', denom)
  searchParams.append('days', range)

  return apiClient
    .get('asset-market-chart', {
      searchParams: searchParams.toString(),
    })
    .json()
}
